import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import LayoutWrap from "../Component/LayoutWrap";
import {
  LuArrowLeft, LuSendHorizonal, LuX, LuBold, LuItalic,
  LuUnderline, LuAlignLeft, LuAlignCenter, LuAlignRight,
  LuAlignJustify, LuMailOpen, LuPencil
} from 'react-icons/lu';
import { dashboardActions } from "../../../_actions";
import { GoMail } from "react-icons/go";
import { FaPlus } from "react-icons/fa6";


import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';


const isMobile = window.innerWidth <= 700;

class InboxActivity extends Component {
  constructor(props) {
    super(props);

    this.editorRef = createRef();

    this.state = {
      selectedMail: 0,
      selectedMailId: "",
      showMobileDetail: false,

      // NEW (Add/Edit Mail)
      showMailForm: false,
      isEdit: false,
      mailData: {
        id: "",
        senderName: "",
        senderEmail: "",
        senderDesignation: "",

        recipientName: "",
        recipientEmail: "",
        received: "",
        cc: "",

        subject: "",
        body: ""
      },
      showInboxIntro: true,
      showInboxIntroEdit: false,
      crrInboxIntro: ""
    };
  }

  componentDidMount() {
    this.props.dispatch(dashboardActions.getInsightMailLibraryList({}));
    this.props.dispatch(dashboardActions.getInsightMailLibraryIntro({}));
  }

  formatDate = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(Number(timestamp));
    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'short' });
    return `${day} ${month}`;
  };

  goToBack = () => {
    if (isMobile && this.state.showMobileDetail) {
      this.setState({ showMobileDetail: false });
    } else {
      window.history.back();
    }
  };

  handleSelect = (mail, i) => {
    if (mail === "intro") {
      this.setState({ showInboxIntro: true })
    } else {
      this.setState({ showInboxIntro: false })
      this.setState({
        selectedMail: i,
        selectedMailId: mail.id,
        showMobileDetail: true
      });
    }
  };

  // ➕ ADD MAIL
  handleAddMail = () => {
    this.setState({ showInboxIntro: false })
    this.setState({
      showMailForm: true,
      isEdit: false,
      mailData: {
        id: "",

        senderName: "",
        senderEmail: "",
        senderDesignation: "",

        recipientName: "",
        recipientEmail: "",
        received: "",
        cc: "",

        subject: "",
        body: ""
      }
    }, () => {
      if (this.editorRef.current) {
        this.editorRef.current.innerHTML = "<p></p>";
      }
    });
  };

  // ✏️ EDIT MAIL
  handleEditMail = (mail) => {
    this.setState({
      showMailForm: true,
      isEdit: true,
      mailData: {
        id: mail.id,

        senderName: mail.senderName,
        senderEmail: mail.senderEmail,
        senderDesignation: mail.senderDesignation,

        recipientName: mail.recipientName,
        recipientEmail: mail.recipientEmail,
        received: mail.received,
        cc: mail.cc,

        subject: mail.subject,
        body: mail.body
      }
    }, () => {
      if (this.editorRef.current) {
        this.editorRef.current.innerHTML = mail.body || "";
      }
    });
  };




  // 💾 SAVE MAIL
  handleSaveMail = () => {
    const { mailData, isEdit } = this.state;
    const body = this.editorRef.current?.innerHTML || "";

    const payload = {

      senderName: mailData.senderName,
      senderEmail: mailData.senderEmail,
      senderDesignation: mailData.senderDesignation,

      recipientName: mailData.recipientName,
      recipientEmail: mailData.recipientEmail,
      received: mailData.received,
      cc: mailData.cc,

      subject: mailData.subject,
      body
    };

    if (isEdit) {
      payload["id"] = mailData.id;
    }

    if (isEdit) {
      this.props.dispatch(dashboardActions.updateInsightMail(payload));
    } else {
      this.props.dispatch(dashboardActions.createInsightMail(payload));
    }

    this.props.dispatch(
      dashboardActions.saveInsightActivityTracking({
        activity: isEdit ? "Mail Updated" : "Mail Created"
      })
    );

    this.setState({ showMailForm: false });
  };






  saveEditInboxIntro = () => {
    const data = {
      inboxIntro: this.state.crrInboxIntro
    };
    this.props.dispatch(dashboardActions.saveInboxIntro(data));
    this.setState({ showInboxIntroEdit: false, crrInboxIntro: "" });
  };



  handleEditInboxIntro = (value) => {
    this.setState({ showInboxIntroEdit: true, crrInboxIntro: value });
  }


  handleInboxIntroChange = (value) => {
    // this.setState({ showInboxIntroEdit: value });
    this.setState({ crrInboxIntro: value });
  }

  allRepliesModal = () => {
    this.props.history.push("/insightadmin/replies");
  };

  render() {
    let { crrInboxIntro, showInboxIntroEdit, showInboxIntro, showMailForm, isEdit, mailData, selectedMail } = this.state;
    let { dashboard } = this.props;
    let { getInsightMailLibraryListData = [], getInsightMailLibraryIntroData: inboxIntroObj = {} } = dashboard;

    const inboxInto = inboxIntroObj?.body ?? "";



    console.log("inboxIntroObj----//--->", inboxIntroObj)
    console.log("crrInboxIntro----//--->", crrInboxIntro)

    const inboxData = getInsightMailLibraryListData.map((mail) => ({
      id: mail.id,

      senderName: mail.senderName,
      senderEmail: mail.senderEmail,
      senderDesignation: mail.senderDesignation,

      recipientName: mail.recipientName,
      recipientEmail: mail.recipientEmail,
      received: mail.received,
      cc: mail.cc,

      date: this.formatDate(mail.createdAt),

      subject: mail.subject,
      body: mail.body
    }));

    let activeMail = getInsightMailLibraryListData[selectedMail];


    const fieldList = [
      { name: "senderName", label: "Sender Name" },
      { name: "senderDesignation", label: "Sender Designation" },
      { name: "senderEmail", label: "Sender Email" },

      { name: "recipientName", label: "Recipient Name" },
      { name: "recipientEmail", label: "Recipient Email" },
      { name: "cc", label: "CC" },

      { name: "received", label: "Received" },
      { name: "subject", label: "Subject" }
    ]



    return (
      <LayoutWrap>
        <div className="h-full flex bg-white">
          <div className="w-full mx-auto bg-white p-4 sm:p-6">

            {/* Header */}
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-5 gap-4">
              <h1 className="text-xl sm:text-2xl font-medium textblack">
                Inbox Library
              </h1>

              <div onClick={() => this.allRepliesModal()} className="w-54 text-left px-6 py-5 bg-indigo-100 transition-all hover:bg-indigo-200">
                <p className="flex items-center text-indigo-600 text-lg font-medium capitalize gap-4">
                  <FaPlus size={22} />
                  <span>All Mail Replies</span>
                </p>
              </div>

            </div>

            <div className="flex flex-1 overflow-hidden">

              {/* SIDEBAR */}
              <aside className="w-full lg:w-[350px] border-r border-gray-300 overflow-y-auto">

                <div
                  onClick={() => this.handleSelect("intro")}
                  className="flex items-center gap-4 border-b border-gray-300 bg-indigo-50 px-3 py-6 transition-colors hover:bg-gray-100 cursor-pointer min-h-24">
                  <div className="flex-shrink-0">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="28"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="text-indigo-600"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <path d="M12 16v-4"></path>
                      <path d="M12 8h.01"></path>
                    </svg>
                  </div>

                  <div className="flex-1 min-w-0">
                    <div className="flex justify-between items-center gap-3">
                      <h3 className="text-lg font-semibold text-gray-900 truncate">
                        Inbox Activity Introduction
                      </h3>

                      <span className="text-sm text-indigo-600 whitespace-nowrap">
                        Today
                      </span>
                    </div>
                  </div>
                </div>


                {inboxData.map((item, i) => (
                  <div
                    key={item.id}
                    onClick={() => this.handleSelect(item, i)}
                    className={`p-3 border-b border-gray-300 cursor-pointer transition-colors flex gap-3 ${selectedMail === i ? 'bg-purple-50' : 'hover:bg-[#F2EEFA]'
                      }`}
                  >
                    <div className="mt-1">
                      {item.unread ? (
                        <GoMail className="textblack" size={24} />
                      ) : (
                        <LuMailOpen className="text-indigo-600" size={24} />
                      )}
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex justify-between items-baseline">
                        <h3 className="text-lg font-medium truncate">{item.senderName}</h3>
                        <span className="text-sm text-indigo-600">{item.date}</span>
                      </div>
                      <p className="text-sm textblack truncate">{item.subject}</p>
                    </div>


                  </div>
                ))}
                <div onClick={this.handleAddMail} className="w-full text-left px-6 py-5 bg-indigo-100 transition-all hover:bg-gray-50">
                  <p className="flex items-center text-indigo-600 text-lg font-medium capitalize gap-4">
                    <FaPlus size={22} />
                    <span>Add New Mail</span>
                  </p>
                </div>
              </aside>

              {showInboxIntro ?
                <>
                  {showInboxIntroEdit ?
                    <main className={`flex-1 flex flex-col bg-white overflow-y-auto ${!this.state.showMobileDetail ? 'hidden lg:flex' : 'flex'}`}>
                      <div className="md:p-6 p-4 w-full">
                        <div className="flex items-center justify-center gap-3 p-4 border-b border-gray-300">
                          <h2 className="md:text-2xl text-xl font-medium mb-6">Inbox Activty Introduction</h2>
                          <div className="flex items-center justify-end gap-3 p-4 border-b border-gray-300">
                            <button onClick={() => this.setState({ showInboxIntroEdit: false })}
                              className="flex items-center gap-2 px-4 py-1.5 border border-gray-300 text-indigo-600 rounded-md font-medium hover:text-indigo-700 hover:bg-indigo-100">
                              <LuX size={18} /> Discard
                            </button>
                            <button onClick={() => this.saveEditInboxIntro()} className="flex items-center gap-2 px-4 py-1.5 bg-indigo-600 text-white rounded-md font-medium hover:bg-indigo-700">
                              Update
                            </button>
                          </div>
                        </div>
                        {/* EDITOR */}
                        <ReactQuill
                          theme="snow"
                          value={crrInboxIntro}
                          onChange={(value) =>
                            this.handleInboxIntroChange(value)
                          }
                          className="custom-quill"
                        />
                      </div>
                    </main>
                    :
                    <main className={`flex-1 flex flex-col bg-white overflow-y-auto ${!this.state.showMobileDetail ? 'hidden lg:flex' : 'flex'}`}>
                      <div className="md:p-6 p-4 w-full">
                        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 py-4 border-b border-gray-200 bg-white rounded-t-xl">
                          <div className="flex items-center ">
                            <div>
                              <h2 className="text-lg md:text-xl font-semibold text-gray-800">
                                Inbox Activity Introduction
                              </h2>
                              <p className="text-sm text-gray-500 mt-1">
                                Manage your inbox introduction content
                              </p>
                            </div>
                          </div>

                          <button
                            onClick={() => this.handleEditInboxIntro(inboxInto)}
                            className="inline-flex items-center justify-center gap-2 px-5 py-2.5
    bg-indigo-600 text-white text-sm font-medium rounded-lg
    shadow-sm hover:bg-indigo-700 hover:shadow-md
    focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2
    transition-all duration-200 active:scale-95"
                          >
                            <LuPencil size={16} />
                            Edit Introduction
                          </button>
                        </div>
                        <div
                          className="textblack text-sm leading-relaxed whitespace-pre-line space-y-4 mt-4"
                          dangerouslySetInnerHTML={{ __html: inboxInto }}
                        />
                      </div>
                    </main>
                  }

                </>
                :
                <>
                  {/* MAIL FORM */}
                  {showMailForm && (
                    <main className="flex-1 flex flex-col bg-white overflow-y-auto">


                      <div className="flex items-center justify-between gap-3 p-4 border-b border-gray-300">
                        <h2 className="text-2xl font-medium">Edit Mail</h2>

                        <div className="flex items-center justify-end  px-4">
                          <button onClick={() => this.setState({ showMailForm: false })}
                            className="flex items-center gap-2 px-4 py-1.5 border border-gray-300 text-indigo-600 rounded-md font-medium hover:text-white hover:bg-indigo-600">
                            <LuX size={18} /> Cancel
                          </button>
                          <button onClick={this.handleSaveMail}
                            className="flex items-center gap-2 px-4 py-1.5 bg-indigo-600 text-white rounded-md font-medium hover:bg-indigo-600">
                            <LuSendHorizonal size={18} />
                            {isEdit ? "Update" : "Send"}
                          </button>
                        </div>
                      </div>

                      <div className="md:p-8 p-4 md:max-w-[90%] w-full mx-auto space-y-6">
                        <div className="grid md:grid-cols-[150px_1fr] grid-cols-[100px_1fr] items-center gap-4">


                          {fieldList.map((field, index) => (
                            <>
                              <label className="md:text-lg text-sm font-medium textblack ">
                                {field.label}
                              </label>

                              <input
                                value={this.state.mailData?.[field.name] || ""}
                                onChange={(e) => {
                                  const value = e.target.value; // ✅ store it first
                                  this.setState((prevState) => ({
                                    mailData: {
                                      ...prevState.mailData,
                                      [field.name]: value
                                    }
                                  }));
                                }}
                                placeholder={field.label}
                                className="border-b border-gray-300 py-2 focus:border-purple-600 outline-none textblack"
                              />
                            </>
                          ))}
                        </div>

                        {/* EDITOR */}
                        <div className="border border-gray-300 rounded-lg overflow-hidden mt-8">
                          {/* Toolbar */}
                          <div className="flex flex-wrap items-center gap-1 p-2 bg-white border-b border-gray-300">
                            <ToolbarButton onClick={() => document.execCommand("bold")} icon={<LuBold />} />
                            <ToolbarButton onClick={() => document.execCommand("italic")} icon={<LuItalic />} />
                            <ToolbarButton onClick={() => document.execCommand("underline")} icon={<LuUnderline />} />
                            <div className="w-px h-6 bg-gray-200 mx-1"></div>
                            {/* Alignment */}
                            <ToolbarButton onClick={() => document.execCommand("justifyLeft")} icon={<LuAlignLeft />} />
                            <ToolbarButton onClick={() => document.execCommand("justifyCenter")} icon={<LuAlignCenter />} />
                            <ToolbarButton onClick={() => document.execCommand("justifyRight")} icon={<LuAlignRight />} />
                            <ToolbarButton onClick={() => document.execCommand("justifyFull")} icon={<LuAlignJustify />} />
                          </div>
                          <div
                            ref={this.editorRef}
                            contentEditable
                            suppressContentEditableWarning
                            className="w-full h-80 p-6 outline-none resize-none textblack leading-relaxed"
                            style={{ direction: "ltr", textAlign: "left" }}
                          />
                        </div>
                      </div>
                    </main>
                  )}

                  {/* VIEW MAIL */}
                  {!showMailForm && activeMail && (
                    <main className="flex-1 p-6">
                      <div className="flex justify-between mb-4">
                        <h2 className="text-xl font-medium">{activeMail.subject}</h2>

                        <button onClick={() => this.handleEditMail(activeMail)}
                          className="flex items-center gap-2 px-4 py-1.5 border border-gray-300 text-indigo-600 rounded-md font-medium hover:text-white hover:bg-indigo-600">
                          <LuPencil /> Edit
                        </button>
                      </div>

                      <p><b>From:</b> {activeMail.senderName} ({activeMail.senderEmail})</p>
                      {activeMail && activeMail.senderDesignation &&
                        <p><b>Designation:</b>{activeMail.senderDesignation}</p>
                      }
                      <p><b>To:</b> {activeMail.recipientName} ({activeMail.recipientEmail})</p>

                      {activeMail && activeMail.cc &&
                        <p><b>CC:</b> {activeMail.cc}</p>
                      }

                      <p><b>Received:</b> {activeMail.received}</p>

                      <div
                        className="mt-4"
                        dangerouslySetInnerHTML={{ __html: activeMail.body }}
                      />
                    </main>
                  )}
                </>
              }





            </div>
          </div>   </div>
      </LayoutWrap>
    );
  }
}
// Sub-component for Toolbar Buttons
const ToolbarButton = ({ icon, onClick }) => (
  <button onClick={onClick} className="p-2 textblack hover:bg-indigo-600 rounded transition-colors">
    {React.cloneElement(icon, { size: 18 })}
  </button>
);

export default connect((state) => ({
  dashboard: state.dashboard,
}))(InboxActivity);